import SliderTimber from '../components/Sliders/SliderTimber';
import SliderCategory from '../components/Sliders/SliderCategory';
import timberHP from '../../images/timber-hp.png';
import Image from 'next/image';


export default function TimberSection({timberApplications, timberSpecies, categories, timbers }) {
  return (
    <div className="mx-2 md:mx-10 lg:mx-10 my-10">
        <div className="text-right my-10">
            <h2 className="text-3xl font-semibold text-primary mb-10">Timber Applications</h2>
            <p className="text-xl text-primary mb-10 ml-0 lg:ml-40">{timberApplications}</p>
        </div>  
        <div className='my-10'>
          <SliderCategory items={categories} prefix="/categories/" />
        </div> 
        <div className='my-10'>
          <Image src={timberHP} alt='Timber'/>
        </div> 
        <div className="text-right my-10">
            <h2 className="text-3xl font-semibold text-primary mb-10">Timber Species</h2>
            <p className="text-xl text-primary mb-10 ml-0 lg:ml-40">{timberSpecies}</p>
        </div>  
        <div className='my-10'>
          <SliderTimber timbers={timbers} />
        </div>
    </div>
  );
}
